export class DisPositionGV {
    id : number;
    positionGVCode : string;
    positionGVName : string;
}